import { componentStyles } from "./live-board-open-button.scss";
import { withGenericConfig } from "/contexts/generic-config-context";

const liveBoardOpenButton = (props) => {
  const { onClick, translate } = props;

  return (
    <div className="live-board-open-button" onClick={onClick}>
      <div className="button-text">{translate("liveBoard.openButton")}</div>
      <div className="pulse-circle" />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(liveBoardOpenButton);
